<template>
  <div class="product-box__segment-header">
    <div
      v-if="highlightBadgeData"
      class="product-box__highlight-article-badge"
    >
      <div
        v-if="highlightBadgeData.text"
        v-html="highlightBadgeData.text"
        class="product-box__highlight-article-text"
      />
      <img
        v-if="highlightBadgeData.icon"
        class="product-box__highlight-article-icon"
        :src="highlightBadgeData.icon"
        alt=""
        width="20"
        height="20"
        aria-hidden="true"
      >
    </div>
    <div class="product-box__header-container">
      <component
        :is="productLink ? 'a' : 'div'"
        :href="productLink"
        class="product-box__header-text"
        :class="{
          'product-box__header-text--with-vintage': productBoxData.vintage
        }"
      >
        <span class="product-box__name">
          <span
            class="product-box__bottle-amount"
            v-if="numberOfBottlesInSet"
          >
            {{ numberOfBottlesInSet }} x
          </span>
          <span
            v-if="productBoxData.vintage"
            class="product-box__vintage"
          >
            {{ productBoxData.vintage }}
          </span>
          {{ productBoxData.description1 }}
        </span>
        <div
          class="product-box__short-description"
          v-if="productBoxData.description2 || productBoxData.shortDescription"
          v-html="productShortDescription"
        />
        <div
          v-if="showInBasket && productBoxData.inBasket"
        >
          <a
            class="product-box__status product-box__status--basket product-box__status--basket-up"
            :href="basketUrl"
          >
            {{ t('ads.ads_top_info.article_in_basket') }}
          </a>
        </div>
      </component>

      <button
        v-if="!productBoxData.zeroPriceItem && productBoxData.valid && !productBoxData.recurringOrderFollowUpPacket"
        class="product-box__button-wishlist"
        :class="{
          'product-box__button-wishlist--filled': isWishlistEnabled && productBoxData.inWishlist && state !== 'loadingWishlist',
          'product-box__button-wishlist--remove': !isWishlistEnabled,
          'product-box__button-wishlist--loading': state === 'loadingWishlist',
        }"
        :aria-label="t('wishlist.default.name')"
        type="button"
        @click.prevent="emit('wishlistClicked')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import jsGlobalConfig from '../../../bps/globals/jsGlobalConfig';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';
  import HighlightArticleData from '@/bps/types/HighlightArticleData';

  const emit = defineEmits(['wishlistClicked']);

  const props = withDefaults(defineProps<{
    productBoxData: ProductBoxData;
    state: string;
    numberOfBottlesInSet?: number;
    productLink?: string;
    showReview?: boolean;
    showInBasket?: boolean;
    isWishlistEnabled?: boolean;
  }>(), {
    numberOfBottlesInSet: null,
    productLink: '',
    showReview: false,
    showInBasket: false,
    isWishlistEnabled: true
  });

  const basketUrl = jsGlobalConfig().getBasketUrl();

  const productShortDescription = computed(() => {
    if (props.productBoxData.description2 && props.productBoxData.shortDescription) {
      return `${props.productBoxData.description2}, ${props.productBoxData.shortDescription}`;
    }
    return props.productBoxData.description2 || props.productBoxData.shortDescription;
  });


  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);

  const highlightBadgeData = computed(() => {
    const textSpacer = '&nbsp;&nbsp;';

    if (highlightArticleData.value) {
      const articleHighlight = highlightArticleData.value;
      articleHighlight.text += textSpacer;
      return articleHighlight;
    }

    if (props.productBoxData.personalPreferenceMessageKey) {
      return {
        style: {},
        text: t(props.productBoxData.personalPreferenceMessageKey) + textSpacer,
        icon: null
      };
    }

    return null;
  });
</script>
